import { render, staticRenderFns } from "./characteristiNav.vue?vue&type=template&id=4cdefa6a"
import script from "./characteristiNav.vue?vue&type=script&lang=js"
export * from "./characteristiNav.vue?vue&type=script&lang=js"
import style0 from "./characteristiNav.vue?vue&type=style&index=0&id=4cdefa6a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cdefa6a')) {
      api.createRecord('4cdefa6a', component.options)
    } else {
      api.reload('4cdefa6a', component.options)
    }
    module.hot.accept("./characteristiNav.vue?vue&type=template&id=4cdefa6a", function () {
      api.rerender('4cdefa6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/characteristiNav.vue"
export default component.exports